import React from "react";
import RcsApiComponent from "../../site/RcsApiComponent";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import Title from "../../UI/Text/Title";

const RcsAPIDashboard = () => {
  return (
    <DashboardLayout>
      <main className="content">
        <div className="container-fluid p-0">
          <Title isButton={false}>
            <b>RCS Docs</b>
          </Title>

          <div className="card">
            <div className="card-body">
              <h3 className="mt-1 main_innerheading">
                RCS API Documentation
              </h3>
              <RcsApiComponent />
            </div>
          </div>
        </div>
      </main>
    </DashboardLayout>
  );
};
export default RcsAPIDashboard;
